// extracted by mini-css-extract-plugin
module.exports = {"tabshorizontal":"tabs_tabshorizontal__6XxXp","tabsul":"tabs_tabsul__T5OUq","tabsli":"tabs_tabsli__3CGK_","tabsliactive":"tabs_tabsliactive__3HfiD"};